import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  public download(
    contents: string,
    fileName = 'file.txt',
    mimeType = 'text/plain'
  ) {
    this.downloadBlob(new Blob([contents], { type: mimeType }), fileName);
  }

  public downloadBlob(blob: Blob, fileName = 'file.txt') {
    const downloadURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = fileName;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadURL);
  }
}
